import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import Button from "react-bootstrap/Button";
import { FaArrowLeft } from "react-icons/fa";
import {
  getAllLabReport,
  resetUpdateLabReportMessage,
  updateLabReport,
} from "../../../store/slices/labReportSlice";
import { useDispatch, useSelector } from "react-redux";
import ReportDetails from "./editLabReportComponent/reportDetails";
import CollectionReceived from "./editLabReportComponent/collectionReceived";
import LabOutsource from "./editLabReportComponent/labOutsource";
import TestAndProfile from "./editLabReportComponent/testAndProfile";
import AssignedAndRemark from "./editLabReportComponent/assignedAndRemark";
import ReportStatus from "./editLabReportComponent/reportStatus";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";

const EditLabReport = () => {
  const dispatch = useDispatch();
  const showMessageAndReset = ShowTostifyMessageAndReset();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const {
    labReport,
    labReportUpdateSuccessMessage,
    labReportUpdateErrorMessage,
  } = useSelector((state) => state.labReport);
  const { userInfo, token } = useSelector((state) => state.auth);
  const labReportId = sessionStorage.getItem("labReportId");
  const newLabReport = Array.isArray(labReport)
    ? labReport.find((r) => r._id === labReportId)
    : labReport;

  const [labReportFormData, setLabReportFormData] = useState({
    collectionDate: "",
    collectionTime: "",
    receivedDate: "",
    receivedTime: "",
    assignedPhysician: "",
    assignedPhysicianName: "",
    assignDoctorDate: "",
    remark: "",
    labReportStatus: "",
    labForOutsource: "",
    labForOutsourceName: "",
    id: newLabReport?._id,
  });
  const [selectAllOutsource, setSelectAllOutsource] = useState(false);
  const [globalOutsourceLab, setGlobalOutsourceLab] = useState(null);
  const clinicId = clinicInfo?.[0]?.clinicId || null;
  const clinicObjId = clinicInfo?.[0]?._id;
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  useEffect(() => {
    dispatch(
      getAllLabReport({
        clinicId,
        id: labReportId,
        token,
      }),
    );
  }, [dispatch, clinicId, labReportId, token]);

  const unmatchedProfileTests = newLabReport?.profiles?.flatMap((profile) =>
    profile.tests?.map((profileTest) => profileTest.clinicTestId),
  );
  const unmatchedTests = newLabReport?.tests?.filter(
    (profileTest) => !unmatchedProfileTests.includes(profileTest.clinicTestId),
  );
  const loggedInClinicId = clinicId;

  const isOwner =
    String(newLabReport?.clinicId?._id || newLabReport?.clinicId) ===
    String(loggedInClinicId);
  useEffect(() => {
    setLabReportFormData((prevState) => ({
      ...prevState,
      collectionDate: newLabReport?.collectionDate
        ? new Date(newLabReport.collectionDate).toISOString().split("T")[0]
        : "",
      collectionTime: newLabReport?.collectionTime || "",
      receivedDate: newLabReport?.receivedDate
        ? new Date(newLabReport.receivedDate).toISOString().split("T")[0]
        : "",
      receivedTime: newLabReport?.receivedTime || "",
      assignedPhysician: newLabReport?.assignedPhysician?._id || "",
      assignedPhysicianName:
        newLabReport?.assignedPhysician?.userId?.name || "",

      assignDoctorDate: newLabReport?.assignDoctorDate
        ? new Date(newLabReport.assignDoctorDate).toISOString().split("T")[0]
        : "",
      remark: newLabReport?.remark || "",
      labReportStatus: newLabReport?.labReportStatus || "",
      labForOutsource: newLabReport?.labForOutsource?._id || "",
      labForOutsourceName: newLabReport?.labForOutsource?.clinicName || "",
      unRegisteredlabForOutsource:
        newLabReport?.unRegisteredlabForOutsource?._id || "",
      unRegisteredlabForOutsourceName:
        newLabReport?.unRegisteredlabForOutsource?.clinicName || "",
      outsourceBy: clinicObjId,
      tests:
        newLabReport?.tests?.map((test) => ({
          id: test._id,
          value: test.value || "",
          rhType: test?.rhType || "",
         positiveNegative: test?.positiveNegative || "",
          isNABL: test?.isNABL || "No",
          receivedStatus: test?.receivedStatus || "",
          sampleType: test?.sampleType || "",
          reportingStatus: test?.reportingStatus || "",
          method: test.method || "",
          sourceType: test.sourceType || "",
          labForOutsource: test?.labForOutsource?._id || "",
          labForOutsourceName: test?.labForOutsource?.clinicName || "",
          unRegisteredlabForOutsource:
            test?.unRegisteredlabForOutsource?._id || "",
          unRegisteredlabForOutsourceName:
            test?.unRegisteredlabForOutsource?.clinicName || "",
          outsourceBy: clinicObjId,
        })) || [],
      profiles:
        newLabReport?.profiles?.map((test) => ({
          id: test._id,
          sampleType: test?.sampleType || "",
          labForOutsource: test?.labForOutsource?._id || "",
          labForOutsourceName: test?.labForOutsource?.clinicName || "",
          unRegisteredlabForOutsource:
            test?.unRegisteredlabForOutsource?._id || "",
          unRegisteredlabForOutsourceName:
            test?.unRegisteredlabForOutsource?.clinicName || "",
          sourceType: test.sourceType || "",
          outsourceBy: clinicObjId,
          cultureMethod: test?.cultureMethod || "",
          organism: test?.organism || "",
          colonyCount: test?.colonyCount || "",
          comment: test?.comment || "",
          fnacDescription: test?.fnacDescription || "",
          tests: test?.tests?.map((tests) => ({
            id: tests?._id,
            value: tests?.value && tests?.value,
            isNABL: tests?.isNABL || "No",
            receivedStatus: tests?.receivedStatus || "",
            reportingStatus: tests?.reportingStatus || "",
            method: tests.method || "",
          })),
        })) || [],
    }));
    setGlobalOutsourceLab({
      value:
        newLabReport?.labForOutsource?._id ||
        newLabReport?.unRegisteredlabForOutsource?._id ||
        "",
      label:
        newLabReport?.labForOutsource?.clinicName ||
        newLabReport?.unRegisteredlabForOutsource?.clinicName ||
        "",
    });
  }, [dispatch, newLabReport, clinicInfo]);

  useEffect(() => {
    const profileSourceTypeStatus = newLabReport?.profiles
      ?.flatMap((profile) => profile.sourceType)
      .includes("inHouse");
    const testSourceTypeStatus = newLabReport?.tests
      ?.flatMap((test) => test.sourceType)
      .includes("inHouse");
    if (profileSourceTypeStatus || testSourceTypeStatus) {
      setSelectAllOutsource(false);
    } else {
      setSelectAllOutsource(true);
    }
  }, [newLabReport, dispatch]);

  useEffect(() => {
    if (labReportUpdateSuccessMessage) {
      dispatch(
        getAllLabReport({
          clinicId,
          id: labReportId,
          token,
        }),
      );

      showMessageAndReset(
        labReportUpdateSuccessMessage,
        showToastifySuccess,
        resetUpdateLabReportMessage,
      );
    }

    if (labReportUpdateErrorMessage) {
      showMessageAndReset(
        labReportUpdateErrorMessage,
        showToastifyError,
        resetUpdateLabReportMessage,
      );
    }
  }, [
    labReportUpdateSuccessMessage,
    labReportUpdateErrorMessage,
    dispatch,
    clinicId,
    labReportId,
    token,
    showMessageAndReset,
  ]);

  const handleChange = (e, name) => {
    if (name === "outsourceLab") {
      setLabReportFormData({
        ...labReportFormData,
        labForOutsource: e.value,
        labForOutsourceName: e.label,
        unRegisteredlabForOutsource: e.value,
        unRegisteredlabForOutsourceName: e.label,
      });
    } else if (name === "assignedPhysician") {
      setLabReportFormData({
        ...labReportFormData,
        assignedPhysician: e.value,
        assignedPhysicianName: e.label,
      });
    } else {
      setLabReportFormData({
        ...labReportFormData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleTestProfileChange = (e, name, index, testIds) => {
    const newValue = e.target ? e.target.value : e.value;
    setLabReportFormData((prevState) => {
      const updatedTests = prevState.tests.map((test) =>
        test.id === index
          ? {
              ...test,
              [name]: newValue,
              ...(name === "labForOutsource" && {
                labForOutsource: e.value,
                labForOutsourceName: e.label,
                unRegisteredlabForOutsource: e.value,
                unRegisteredlabForOutsourceName: e.label,
              }),
            }
          : test,
      );
      const updatedProfiles = prevState.profiles.map((profile) =>
        profile.id === index
          ? {
              ...profile,
              [name]: newValue,
              ...(name === "labForOutsource" && {
                labForOutsource: e.value,
                labForOutsourceName: e.label,
                unRegisteredlabForOutsource: e.value,
                unRegisteredlabForOutsourceName: e.label,
              }),
              tests: profile.tests.map((test) =>
                test.id === testIds ? { ...test, [name]: newValue } : test,
              ),
            }
          : profile,
      );
      return {
        ...prevState,
        tests: updatedTests,
        profiles: updatedProfiles,
      };
    });
    if (name === "labForOutsource") {
      setLabReportFormData((prevState) => ({
        ...prevState,
        labForOutsource: e.value,
        labForOutsourceName: e.label,
        unRegisteredlabForOutsource: "",
        unRegisteredlabForOutsourceName: "",
      }));
      setGlobalOutsourceLab({
        value: "",
        label: "",
      });
      setSelectAllOutsource(false);
    }
  };

  const handleUpdateLabReport = (e) => {
    e.preventDefault();

    // Validation for required date and time fields
    if (
      !labReportFormData.collectionDate ||
      !labReportFormData.collectionTime ||
      !labReportFormData.receivedDate ||
      !labReportFormData.receivedTime
    ) {
      showToastifyError(
        "Please provide Collection Date, Collection Time, Received Date, and Received Time"
      );
      return;
    }

    const updatedProfiles = labReportFormData.profiles?.map((formProfile) => {
      const origProfile = newLabReport?.profiles?.find(
        (p) => String(p._id) === String(formProfile.id),
      );
      if (!origProfile) return formProfile;

      const pName = origProfile.profileName?.toLowerCase() || "";
      const isLFT =
        pName.includes("liver function test") || pName.includes("lft");
      const isLipid = pName.includes("lipid profile");
      const isHba1c =
        pName.includes("hba1c") ||
        origProfile.tests?.some((t) => {
          const tn = t.testName?.toLowerCase()?.trim() || "";
          return (
            tn.includes("hba1c") ||
            tn.includes("hemoglobin a1c") ||
            tn.includes("haemoglobin a1c")
          );
        });

      const getFormVal = (names) => {
        const aliases = Array.isArray(names) ? names : [names];
        const origTest = origProfile.tests?.find((t) => {
          const tn = t.testName?.toLowerCase()?.trim() || "";
          return aliases.some((a) => tn === a.toLowerCase().trim());
        });
        if (!origTest) return NaN;
        const formTest = formProfile.tests?.find(
          (t) => String(t.id) === String(origTest._id),
        );
        return parseFloat(formTest?.value);
      };

      const calculatedMap = new Map();

      // HbA1c -> ABG
      if (isHba1c) {
        const origHbA1c = origProfile.tests?.find((t) => {
          const tn = t.testName?.toLowerCase()?.trim() || "";
          const isAbg =
            tn.includes("abg") || tn.includes("average blood glucose");
          return (
            !isAbg &&
            (tn === "hba1c" ||
              tn.includes("hba1c") ||
              tn.includes("hemoglobin a1c") ||
              tn.includes("haemoglobin a1c"))
          );
        });
        const origAbg = origProfile.tests?.find((t) => {
          const tn = t.testName?.toLowerCase()?.trim() || "";
          return tn.includes("abg") || tn.includes("average blood glucose");
        });

        if (origHbA1c && origAbg) {
          const formHbA1c = formProfile.tests?.find(
            (t) => String(t.id) === String(origHbA1c._id),
          );
          const hVal = parseFloat(formHbA1c?.value);
          if (!isNaN(hVal) && hVal > 0) {
            calculatedMap.set(
              String(origAbg._id),
              (28.7 * hVal - 46.7).toFixed(2),
            );
          }
        }
      }

      // LFT
      if (isLFT) {
        const total = getFormVal(["bilirubin total"]);
        const direct = getFormVal(["bilirubin direct"]);
        if (!isNaN(total) && !isNaN(direct)) {
          const indirectTest = origProfile.tests?.find(
            (t) => t.testName?.toLowerCase()?.trim() === "bilirubin indirect",
          );
          if (indirectTest)
            calculatedMap.set(
              String(indirectTest._id),
              (total - direct).toFixed(2),
            );
        }

        const totalProtein = getFormVal(["total protein"]);
        const albumin = getFormVal(["albumin(alb)", "albumin"]);
        let globulinVal = NaN;
        if (!isNaN(totalProtein) && !isNaN(albumin)) {
          globulinVal = totalProtein - albumin;
          const globulinTest = origProfile.tests?.find(
            (t) => t.testName?.toLowerCase()?.trim() === "globulin",
          );
          if (globulinTest)
            calculatedMap.set(
              String(globulinTest._id),
              globulinVal.toFixed(2),
            );
        }

        if (!isNaN(albumin) && !isNaN(globulinVal) && globulinVal !== 0) {
          const ratio = albumin / globulinVal;
          const agTest = origProfile.tests?.find(
            (t) => t.testName?.toLowerCase()?.trim() === "alb/glb ratio",
          );
          if (agTest)
            calculatedMap.set(
              String(agTest._id),
              parseFloat(Math.round(ratio * 100) / 100).toFixed(1),
            );
        }
      }

      // Lipid
      if (isLipid) {
        const chol = getFormVal(["cholesterol"]);
        const hdl = getFormVal(["hdl"]);
        const tg = getFormVal([
          "triglycerides(tg)",
          "triglycerides",
          "triglycerides (tg)",
        ]);

        let vldl = NaN;
        if (!isNaN(tg)) {
          vldl = tg / 5;
          const vldlTest = origProfile.tests?.find(
            (t) => t.testName?.toLowerCase()?.trim() === "vldl",
          );
          if (vldlTest)
            calculatedMap.set(String(vldlTest._id), vldl.toFixed(2));
        }

        let ldl = NaN;
        if (!isNaN(chol) && !isNaN(hdl) && !isNaN(tg)) {
          ldl = chol - hdl - tg / 5;
          const ldlTest = origProfile.tests?.find(
            (t) => t.testName?.toLowerCase()?.trim() === "ldl",
          );
          if (ldlTest) calculatedMap.set(String(ldlTest._id), ldl.toFixed(2));
        }

        if (!isNaN(chol) && !isNaN(hdl) && hdl !== 0) {
          const cholHdlTest = origProfile.tests?.find((t) => {
            const tn = t.testName?.toLowerCase()?.trim();
            return tn === "chol/hdl ratio" || tn === "chol hdl ratio";
          });
          if (cholHdlTest)
            calculatedMap.set(
              String(cholHdlTest._id),
              (chol / hdl).toFixed(2),
            );
        }

        if (!isNaN(ldl) && !isNaN(hdl) && hdl !== 0) {
          const ldlHdlTest = origProfile.tests?.find((t) => {
            const tn = t.testName?.toLowerCase()?.trim();
            return tn === "ldl/hdl ratio" || tn === "ldl hdl ratio";
          });
          if (ldlHdlTest)
            calculatedMap.set(String(ldlHdlTest._id), (ldl / hdl).toFixed(2));
        }
      }

      if (calculatedMap.size === 0) return formProfile;

      return {
        ...formProfile,
        tests: formProfile.tests?.map((t) => {
          const calcVal = calculatedMap.get(String(t.id));
          return calcVal !== undefined ? { ...t, value: calcVal } : t;
        }),
      };
    });

    dispatch(
      updateLabReport({
        labDetails: {
          ...labReportFormData,
          profiles: updatedProfiles,
          appointmentId: newLabReport?.appointmentId,
          updatedBy: userInfo?._id,
          token,
        },
      }),
    );
  };

  const handleSelectAllOutsourceToggle = () => {
    setSelectAllOutsource((prevSelectAllOutsource) => {
      const newSelectAllOutsource = !prevSelectAllOutsource;
      setLabReportFormData((prevState) => ({
        ...prevState,
        tests: prevState.tests.map((test) => ({
          ...test,
          sourceType: newSelectAllOutsource ? "outSource" : "inHouse",
        })),
        profiles: prevState.profiles.map((profile) => ({
          ...profile,
          sourceType: newSelectAllOutsource ? "outSource" : "inHouse",
        })),
      }));
      return newSelectAllOutsource;
    });
  };

  useEffect(() => {
    if (selectAllOutsource && globalOutsourceLab) {
      setLabReportFormData((prevState) => ({
        ...prevState,
        tests: prevState.tests.map((test) => ({
          ...test,
          sourceType: "outSource",
          labForOutsource: globalOutsourceLab.value,
          unRegisteredlabForOutsource: globalOutsourceLab.value,
        })),
        profiles: prevState.profiles.map((profile) => ({
          ...profile,
          sourceType: "outSource",
          labForOutsource: globalOutsourceLab.value,
          unRegisteredlabForOutsource: globalOutsourceLab.value,
        })),
      }));
    }
  }, [selectAllOutsource, globalOutsourceLab, setLabReportFormData]);

  const handleGlobalLabChange = (selectedOption) => {
    setGlobalOutsourceLab(selectedOption);
    if (selectAllOutsource) {
      setLabReportFormData((prevState) => ({
        ...prevState,
        labForOutsource: selectedOption.value || "",
        labForOutsourceName: selectedOption.label || "",
        unRegisteredlabForOutsource: selectedOption.value || "",
        unRegisteredlabForOutsourceName: selectedOption.label || "",
        tests: prevState.tests.map((test) => ({
          ...test,
          labForOutsource: selectedOption.value,
          labForOutsourceName: selectedOption.label,
        })),
        profiles: prevState.profiles.map((profile) => ({
          ...profile,
          labForOutsource: selectedOption.value,
          labForOutsourceName: selectedOption.label,
        })),
      }));
    }
  };

  const handleIndividualLabChange = (selectedOption, id, type) => {
    setLabReportFormData((prevState) => ({
      ...prevState,
      [type]: prevState[type].map((item) =>
        item.id === id
          ? {
              ...item,
              labForOutsource: selectedOption.value,
              unRegisteredlabForOutsource: selectedOption.value,
            }
          : item,
      ),
    }));
  };
  const currentClinicId = clinicId;
  const handleShowGlobalViewModal = useCallback(
    (item) => {
      if (item?.reportType === "allReports") {
        sessionStorage.setItem("allReportsId", item?.id);
        sessionStorage.removeItem("outSourceToId");
        sessionStorage.removeItem("outSourceFromId");
      } else if (item?.reportType === "outSourceTo") {
        sessionStorage.setItem("outSourceToId", item?.id);
        sessionStorage.removeItem("outSourceFromId");
        sessionStorage.removeItem("allReportsId");
      } else if (item?.reportType === "outSourceFrom") {
        sessionStorage.setItem("outSourceFromId", item?.id);
        sessionStorage.removeItem("outSourceToId");
        sessionStorage.removeItem("allReportsId");
      }

      sessionStorage.setItem("patientId", newLabReport?.patientId?._id);
      sessionStorage.setItem("appointmentId", newLabReport?.appointmentId);

      navigate("/labReportPdf");
    },
    [navigate, newLabReport],
  );
  const isReceiverClinic =
    newLabReport?.labForOutsource &&
    String(newLabReport?.labForOutsource?._id) === String(currentClinicId);
  return (
    <>
    <button
        className="btn btn-sm btn-primary mt-3 mb-3 px-3 py-2 d-flex align-items-center gap-2"
        onClick={goBack}
      >
        <FaArrowLeft />
        Goto LabReport
      </button>
      <form onSubmit={handleUpdateLabReport}>
        <ReportDetails />
        <CollectionReceived
          labReportFormData={labReportFormData}
          handleChange={handleChange}
        />
        <LabOutsource
          labReportFormData={labReportFormData}
          handleChange={handleChange}
          handleSelectAllOutsourceToggle={handleSelectAllOutsourceToggle}
          selectAllOutsource={selectAllOutsource}
          handleGlobalLabChange={handleGlobalLabChange}
          globalOutsourceLab={globalOutsourceLab}
          isReceiverClinic={isReceiverClinic}
        />
        <TestAndProfile
          labReportFormData={labReportFormData}
          handleChange={handleChange}
          newLabReport={newLabReport}
          handleTestProfileChange={handleTestProfileChange}
          unmatchedTests={unmatchedTests}
          selectAllOutsource={selectAllOutsource}
          setSelectAllOutsource={setSelectAllOutsource}
          setLabReportFormData={setLabReportFormData}
          handleIndividualLabChange={handleIndividualLabChange}
          isOwner={isOwner}
          loggedInClinicId={loggedInClinicId}
        />
        <AssignedAndRemark
          labReportFormData={labReportFormData}
          handleChange={handleChange}
        />
        <ReportStatus
          labReportFormData={labReportFormData}
          handleChange={handleChange} 
        />
        <br />
        {/* <div className="text-end">
          <Button variant="primary" type="submit" className="p-2">
            Submit
          </Button>
        </div> */}
        <div className="text-end d-flex justify-content-end gap-2">
          <Button
            variant="secondary"
            type="button"
            className="p-2"
            onClick={() =>
              handleShowGlobalViewModal({
                id: newLabReport?._id,
                patientId: newLabReport?.patientId?._id,
                appointmentId: newLabReport?.appointmentId,
                reportType: "allReports",
              })
            }
          >
            Preview
          </Button>

          <Button variant="primary" type="submit" className="p-2">
            Submit
          </Button>
        </div>
      </form>
    </>
  );
};

export default EditLabReport;
